import { Component, Input, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../../core';
import { CurvaAbcVendaPerspectiva, isPerspectivaSegmentoItem, isPerspectivaSegmentoCliente } from '../curva-abc-venda-perspectiva';
import { CurvaAbcVenda } from '../../curva-abc-venda';
import { CurvaAbcVendaPerspectivaHttpService } from '../services';
import { CurvaAbcVendaTableComponent } from '../../table';
import { CurvaAbcVendaFilter, CurvaAbcVendaFilterStorageService } from '../../filter';


interface Config {
    isPerspectivaSegmentoItem: boolean;
    isPerspectivaSegmentoCliente: boolean;
    isShowHeader?: boolean;
}

@Component({
    selector: 'sgt-curva-abc-venda-perspectiva-content',
    templateUrl: './curva-abc-venda-perspectiva-content.component.html',
    styleUrls: ['./curva-abc-venda-perspectiva-content.component.less']
})
export class CurvaAbcVendaPerspectivaContentComponent implements OnInit, OnDestroy {
    config: Config;
    @Input() perspectiva: CurvaAbcVendaPerspectiva;
    @Input() filter: CurvaAbcVendaFilter;
    @Input() filterStorageKey: string = null;
    @ViewChild('table') table: CurvaAbcVendaTableComponent;

    currentSub$: Subscription;
    curvaAbcVenda: CurvaAbcVenda;

    constructor(private messageService: MessageService,
                private curvaAbcVendaFilterStorageService: CurvaAbcVendaFilterStorageService,
                private curvaAbcVendaPerspectivaHttpService: CurvaAbcVendaPerspectivaHttpService) {}

    ngOnInit(): void {
        this.createConfig();
    }

    private createConfig() {
        this.config = {
            isPerspectivaSegmentoItem: isPerspectivaSegmentoItem(this.perspectiva?.id ?? null),
            isPerspectivaSegmentoCliente: isPerspectivaSegmentoCliente(this.perspectiva?.id ?? null)
        };
        this.config.isShowHeader = this.config.isPerspectivaSegmentoItem || this.config.isPerspectivaSegmentoCliente;
    }

    private setStorage() {
        this.curvaAbcVendaFilterStorageService.set(this.filter, this.filterStorageKey);
    }

    search() {
        this.curvaAbcVenda = null
        this.currentSub$?.unsubscribe();
        this.currentSub$ = this.curvaAbcVendaPerspectivaHttpService.search(this.perspectiva, this.filter, this.getOrderBy(), this.getOrderByDir())
            .pipe(
                take(1)
            )
            .subscribe(
                curvaAbcVenda => {
                    this.curvaAbcVenda = curvaAbcVenda;
                    setTimeout(() => this.table.refresh(), 0);
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, `Ocorreu um erro ao consultar a Curva ABC de Vendas por ${this.perspectiva?.nome}`, error);
                }
            );
    }

    getOrderBy(): number {
        return this.table?.getOrderBy();
    }

    getOrderByDir(): string {
        return this.table?.getOrderByDir()
    }

    onChangeIdTipoClassificacao() {
        this.setStorage();
        this.search();
    }

    ngOnDestroy() {
        this.currentSub$?.unsubscribe();
    }
}
